import { useCallback, useRef } from 'react';
import { carregarDadosDocumentoUc } from '../services/dadosDocumentoUc';
import type { DadosDocumentoUc } from '../lib/dadosDocumentoUc';

type UcComId = Parameters<typeof carregarDadosDocumentoUc>[0] & { id?: number | string | null };

/**
 * Completa o formulário de documento com o que falta no cadastro da UC
 * (negociação do CRM e última fatura — ver src/lib/dadosDocumentoUc.ts).
 *
 * A busca volta depois do preenchimento pela UC. Se nesse meio-tempo a pessoa
 * trocou de UC, tirou a UC ou fechou o modal, a resposta chega atrasada e é
 * descartada — senão o contato de um cliente cairia no formulário de outro.
 */
export function useCompletarDadosUc() {
    const alvo = useRef<number | string | null>(null);

    const completar = useCallback((uc: UcComId, aplicar: (dados: DadosDocumentoUc) => void) => {
        const id = uc.id ?? null;
        alvo.current = id;
        if (id === null) return;
        carregarDadosDocumentoUc(uc).then(dados => {
            if (alvo.current === id) aplicar(dados);
        });
    }, []);

    /** A UC saiu do formulário: resposta que ainda estiver a caminho não vale mais. */
    const esquecer = useCallback(() => { alvo.current = null; }, []);

    return { completar, esquecer };
}
